module.exports = __webpack_public_path__ + "assets/devices/TMD-560-PG2-3fe6e51795f154dd7e65358f20f9e5bb.svg";